import { useContext } from "react";
import { Pane, Shortener, Link } from "components/materials";
import { hover } from "glamor";
import { ArrowRightIcon } from "evergreen-ui";
import { ThemeContext } from "helpers/utilities";

export function LinkCell({ name, url, characterLimit = 32 }) {
  const theme = useContext(ThemeContext);

  return (
    <Pane is={Link} to={url}>
      <Pane
        alignItems="center"
        cursor="pointer"
        display="flex"
        justifyContent="space-between"
      >
        <Pane alignItems="center" display="flex">
          <Shortener
            className={hover({
              textDecoration: "underline",
            })}
            color={theme.colors.linkBlue}
            fontSize="14px"
            limit={characterLimit}
            size={400}
            text={name}
          />
        </Pane>
        <ArrowRightIcon color={theme.colors.linkBlue} />
      </Pane>
    </Pane>
  );
}
